import {
  autopilotPrompt,
  autopilotSettings,
  manageSalesBotFeature,
  salesBotPredict,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function sendDemoPredict(message, conversationId = null) {
  return apiClient.create(
    salesBotPredict,
    {
      prospect_message: message,
      ...(conversationId ? { conversation_id: conversationId } : {}),
    },
    true
  );
}

export function manageSalesBot(data) {
  return apiClient.create(manageSalesBotFeature, { action: data }, true);
}

export function saveAutopilotPrompt(prompt) {
  return apiClient.create(
    autopilotPrompt,
    { salesbot_system_prompt: prompt },
    true
  );
}

export function getAutopilotPrompt() {
  return apiClient.get(autopilotPrompt, {}, true);
}

export function getAutopilotSettings() {
  return apiClient.get(autopilotSettings, {}, true);
}

export function saveAutopilotSettings(settings) {
  return apiClient.create(autopilotSettings, settings, true);
}
